import CONSTANTES from '../constantes';
import { takeEvery, call, put,all } from 'redux-saga/effects'
import {message} from 'antd'
import { actionEstablecerSesion, actionObtenerUsuario, actionObtenerUsuarios, actionPutUsuarioRegistrado, actionGetUsuarioEdit } from "../acciones/accionesUsuario";
const axios = require('axios');

const loginDjango = (datos) => axios({
  method: 'post',
  url:`${CONSTANTES.URL_API}/api-token-auth/`,
  data: datos,
  //headers: {'Content-Type': 'application/json'}
})
.then(response => { 
	return response.data.token
})
.catch(error => {
    return error.response
});


const getUser = (token) => fetch(`${CONSTANTES.URL_API}/my_user_panel/`,
//const getUser = (token) => fetch(`${CONSTANTES.URL_API}/my_user/`,
  {
    method: 'GET',
    headers: new Headers({
      'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {

  })


function* sagaLoginFirebase(values) {
  try {
    let token = yield call(loginDjango, values.values)
    let [usuario]= yield all([
      call(getUser, token)
    ])
    if (token && usuario &&token.status!==400) {
      
      localStorage.setItem('userToken', token);
      yield put(actionEstablecerSesion(true))
      yield put(actionObtenerUsuario(usuario))
      message.success("Bienvenido");
    }
    else{
      yield put(actionEstablecerSesion(false))
      message.error("Error en tus credenciales de acceso");
    }
  }
  catch (error) {
    console.log(error)
  }
}


function* sagaGetUsuario() {
  try {
    let token = localStorage.getItem('userToken');
    const usuario = yield call(getUser, token);
    if (usuario) {
      yield put(actionObtenerUsuario(usuario))
    }

  } catch (error) {

    console.log(error)
  }
}



const getUsuariosSistema = () => fetch(`${CONSTANTES.URL_API}/panel/users/`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {

  })

  const getUsuariosFilter = (filter) => fetch(`${CONSTANTES.URL_API}/panel/users/?nombre=${filter}`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {

  })

function* sagasGetUsuarios(values) {
  try {
    if (values.filter) {
      let usuarios = yield call(getUsuariosFilter, values.filter);
      if (usuarios) {
        yield put(actionObtenerUsuarios(usuarios))
      }
    }
    else {
      let usuarios = yield call(getUsuariosSistema);
      if (usuarios) {
        yield put(actionObtenerUsuarios(usuarios))
      }
    }
    

  } catch (error) {

    console.log(error)
  }
}


const registroUsuario = (datos) => fetch(`${CONSTANTES.URL_API}/panel/users-post/`,
  {
    method: 'POST',
    body: JSON.stringify(datos),
    headers: new Headers({
      //'Authorization':'Token '+userToken,
      'Content-Type': 'application/json'
    })
  })
  .then(response => {
    return response.json()
  })
  .catch(e => {
    console.log(e)
  })


function* sagasRegistroUsuario(values) {
  try {
     let datosNewUser=values.values
     const usuario = yield call(registroUsuario, datosNewUser);
     console.log(usuario)
    if(usuario){
      let usuarioComplete = yield call(getDetailUsuario, usuario.id)
      yield put(actionPutUsuarioRegistrado(usuarioComplete))
      message.success('Usuario Registrado')
    }
  } catch (error) {
    console.log(error)
  }
}



const EditarUsuario=(idUsuario,usuario)=> fetch(`${CONSTANTES.URL_API}/panel/users-post/${idUsuario}/`,
{
  method: 'PATCH',
  body:JSON.stringify(usuario),
  headers: new Headers({
    'Content-Type': 'application/json'
})
})
.then(response=>{
    return response.json()
  })
  .catch(e=>{
    console.log(e)
  })

  const getDetailUsuario = (idUsuario) => fetch(`${CONSTANTES.URL_API}/panel/users/${idUsuario}/`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {

  })

function* sagasEditarUsuario(values) {
  try {
    const idUsuario=values.idUsuario
    console.log(values)
    let usuarioPost = yield call(EditarUsuario, idUsuario, values.values)
    console.log(usuarioPost)
    if (usuarioPost) {
      let usuario = yield call(getDetailUsuario, usuarioPost.id)
      yield put(actionGetUsuarioEdit(usuario));
      message.success("Usuario Editado");
    }
    else {
      message.success("Usuario Editado");
    }
  } catch (error) {
    console.log(error);
  }
}


function* sagasEliminarUsuario(values) {
  try {
    const idUsuario=values.idUsuario
    let usuarioEdit = yield call(EditarUsuario, idUsuario, {is_active:false})
    if (usuarioEdit) {
      let usuarios = yield call(getUsuariosSistema)
      yield put(actionObtenerUsuarios(usuarios))
      message.success("Usuario Eliminado");
    }
    else {
      message.success("Usuario Eliminado");
    }
  } catch (error) {
    console.log(error);
  }
}


export default function* SagasUsuario() {
  yield takeEvery(CONSTANTES.INICIAR_SESION, sagaLoginFirebase)
  yield takeEvery(CONSTANTES.GET_USUARIO, sagaGetUsuario)
  yield takeEvery(CONSTANTES.GET_USUARIOS,sagasGetUsuarios)
  yield takeEvery(CONSTANTES.REGISTRO_USUARIO, sagasRegistroUsuario)
  yield takeEvery(CONSTANTES.EDITAR_USUARIO, sagasEditarUsuario)
  yield takeEvery(CONSTANTES.ELIMINAR_USUARIO, sagasEliminarUsuario)

}